<template>
  <info-pane :loading="!document">
    <div
      v-if="document"
      class="px-8 py-16"
    >
      <v-row>
        <v-col cols="1">
          <v-icon
            class="mt-2"
            color="darkslategray"
          >
            bx-file
          </v-icon>
        </v-col>
        <v-col>
          <h2>
            {{ document.name }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="signedBy">
        <v-col>
          <h4 class="subheader">
            Signed by
          </h4>
          {{ signedBy }}
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <download-document-btn :document="document" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4 class="subheader">
            Associated assets
          </h4>
          <v-data-table
            :headers="assetHeaders"
            :items="assets"
            show-expand
          >
            <template #[`item.assetType`]="{ item }">
              <asset-type-label :asset-type="item.assetType" />
            </template>
            <template #[`item.assetName`]="{ item }">
              <router-link :to="{ name: 'register.assets.info', params: { assetId: item.id }}">
                {{ item.assetName }}
              </router-link>
            </template>
            <template #expanded-item="{ item }">
              <td>
                <div v-if="item.details">
                  {{ item.details }}
                </div>
                <div
                  v-else
                  class="font-italic"
                >
                  No details
                </div>
              </td>
              <td>
                <asset-value-display :asset="item" />
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </info-pane>
</template>

<script>
import InfoPane from './InfoPane.vue'
import DownloadDocumentBtn from './DownloadDocumentBtn.vue'
import AssetValueDisplay from './AssetValueDisplay.vue'
import AssetTypeLabel from './AssetTypeLabel.vue'

export default {
  name: 'RegisterDocumentsInfoPane',
  components: {
    AssetTypeLabel,
    AssetValueDisplay,
    DownloadDocumentBtn,
    InfoPane
  },
  props: {
    documentId: { type: String, required: true }
  },
  data: function () {
    return {
      assetHeaders: [
        { text: 'Name', value: 'assetName' },
        { text: 'Type', value: 'assetType' },
        { text: '', value: 'data-table-expand' }
      ]
    }
  },
  computed: {
    document() {
      return this.getVaultDocumentById(this.documentId)
    },
    assets() {
      return this.getAssetsForDocument(this.document)
    },
    signedBy() {
      if (!this.document) {
        return ''
      }
      return [this.document.signatoryName, this.document.counterpartyName]
        .filter((item) => item)
        .join(', ')
    }
  },
  beforeCreate() {
    this.dispatchActions([
      'get_assets',
      'get_vaultDocuments',
      'get_counterpartyUsers'
    ])
    this.mapGetters(['getVaultDocumentById', 'getAssetsForDocument'])
  }
}
</script>
<style lang="scss" scoped>
.subheader {
  text-transform: uppercase;
  color: var(--v-darkgray-base);
}
</style>
